<template>
  <div>
    <busy-indicator ref="main-busy-indicator"></busy-indicator>

    <!-- header -->
    <div class="row">
      
      <div class="col-md-7">
        <div style="font-size:1em;display:inline-block">
          <span data-toggle="popover" title="Help" data-content="Input some tags in the textField below, and press enter - you should get some hints.<br /><br />Examples:<br /><b>[Sad]</b> - will give you hints for every action that can be performed when a character feels sad<br /><b>[Breathing;]</b> - will give you all hints related to breathing<br /><b>[Breathing;Sad]</b> - will give you hints related to breathing when a character is sad">
            <i style="font-size:1em;" class="fa fa-question-circle"></i>
            
          </span>
          <span style="font-size:18px">
            Hint tool
          </span>
          
        </div>
      </div>

      <div class="col-md-5">
        <button type="button" class="btn btn-primary btn-flat pull-right" @click="reloadInitialHints">Reload initial hints</button>
      </div>

    </div>

    <hr />

    <div>
      <!-- Body -->
      <input type="text" id="inputTag" class="form-control" ref="input-tag" placeholder="Input some [Tag]" title="Examples: [Sad], [Breathing;], [Breathing;Sad]" v-on:keyup.enter="getHints()" value="" />
      <br />
      <div id="divTextHints" class="form-control" style="border:1px solid black; height: 500px; overflow-y:scroll">

        <div v-if="selectedHints.loaded">
          <div id="availableTextHintDivAccordion" class="panel-group" v-if="selectedHints.hintData.length > 0" role="tablist" aria-multiselectable="true">

            <div class="panel panel-default" v-for="item in selectedHints.hintData">
              <div class="panel-heading" role="tab" :id="item.id+'-collapse-heading'">
                <h4 class="panel-title">
                  <a role="button" data-toggle="collapse" data-parent="#availableTextHintDivAccordion" :href="'#'+item.id+'-collapse-one'" aria-expanded="true" :aria-controls="item.id+'-collapse-one'">
                    {{item.actionTag}}
                    <i>{{((item.type != '' && item.type != null) ? ' - ' + item.type : '')}}</i>
                    {{((item.asIn != '' && item.asIn != null) ? ' as in ' : '')}}
                    <b>{{item.asIn}}</b>
                  </a>
                </h4>
              </div>
              <div :id="item.id+'-collapse-one'" v-bind:class="{in: isAccordionExpanded }" class="panel-collapse collapse" role="tabpanel" :aria-labelledby="item.id+'-collapse-heading'">
                <div class="panel-body">
                  <div v-if="selectedHints.controlMode === controlModes.hints">
                    <ul>
                      <li v-for="value in item.values" @click="$emit('onHintSelected', $event)" class="hintValueLi">
                        {{value}}
                      </li>
                    </ul>
                  </div>
                  <div v-else-if="selectedHints.controlMode === controlModes.synonyms" class="nav-tabs-custom">
                    <div v-if="item.valuesAll.length > 0">
                        <ul>
                          <li v-for="value in item.valuesAll" @click="$emit('onHintSelected', $event)" class="hintValueLi">
                            {{value}}
                          </li>
                        </ul>
                    </div>
                    <div v-else>
                      <div class="box">
                        <div v-if="item.valuesHigh.length > 0">
                          <div class="box-header with-border">
                            <h3 class="box-title">High relevance</h3>
                          </div><!-- /.box-header -->
                          <div class="box-body">
                            <ul>
                              <li v-for="value in item.valuesHigh" @click="$emit('onHintSelected', $event)" class="hintValueLi">
                                {{value}}
                              </li>
                            </ul>
                          </div><!-- /.box-body -->
                        </div>

                      <div v-if="item.valuesMedium.length > 0">
                        <div class="box-header with-border">
                        <h3 class="box-title">Medium relevance</h3>
                      </div><!-- /.box-header -->
                      <div class="box-body">
                        <ul>
                          <li v-for="value in item.valuesMedium" @click="$emit('onHintSelected', $event)" class="hintValueLi">
                            {{value}}
                          </li>
                        </ul>
                      </div><!-- /.box-body -->
                      </div>

                      <div v-if="item.valuesLow.length > 0">
                        <div class="box-header with-border">
                          <h3 class="box-title">Low relevance</h3>
                        </div><!-- /.box-header -->
                        <div class="box-body">
                          <ul>
                            <li v-for="value in item.valuesLow" @click="$emit('onHintSelected', $event)" class="hintValueLi">
                              {{value}}
                            </li>
                          </ul>
                        </div><!-- /.box-body -->
                      </div>

                    </div><!-- /.box -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div v-else>
            Sorry no hints available :(
          </div>
        </div>

      </div>
      <br />
      <div>
        <div>
          <input ref="input-import-file" type="file" name="fileImport" id="fileImport" class="inputfile inputfile-6" style="display:none" accept=".csv" v-on:change="onFileLoaded" />
          <label for="fileImport"><span id="downloadFile"></span><strong><i class="fa fa-download" aria-hidden="true"></i> Load file</strong></label>
        </div>
        <p id="extFileMessage" class="hidden ks-color-red">
        </p>
      </div>

    </div>
  </div>
</template>

<script>
import Firebase from "firebase";
import "bootstrap3";
import _ from "lodash";
import CSV from "../js/csv";
import BusyIndicator from "./BusyIndicator";
import StoryProcessor from "../js/storyProcessor";
const machina = require("machina");

let events = {
  loaded: "loaded"
};

let controlModes = Object.freeze({ hints: 0, synonyms: 1 });

$(document).ready(function() {
  $('[data-toggle="popover"]').popover({ container: "body", html: true });
});

export default {
  name: "TagTip",
  inject: ["storyProcessor"],
  data: function() {
    return {
      state: undefined,

      controlModes: controlModes,

      selectedHints: {
        loaded: false,
        hintData: [],
        controlMode: controlModes.synonyms
      }
    };
  },
  components: {
    "busy-indicator": BusyIndicator
  },
  computed: {
    /**
     * Used to determin if the accordion should start expanded (for hints or of there is only a single selection available)
     */
    isAccordionExpanded: function(){
      var dataToReturn = ((this.selectedHints.hintData.length === 1 && this.selectedHints.controlMode === controlModes.synonyms) || this.selectedHints.controlMode === controlModes.hints);

      return dataToReturn;
    },
  },

  methods: {
    /**
     * Reloads initial hints data from Firebase/GDoc
     */
    reloadInitialHints: function() {
      var that = this;

      that.state.transition("Loading");

      that.storyProcessor
        .loadHintData(true)
        .done(function() {
          that.state.transition("Loaded");
        })
        .fail(function() {
          that.state.transition("LoadError");
        });
    },

    /**
     * Return hints, based on passed string
     * @param {string} value Tag to get hints for - for example: [Sad] or [Breathing;Sad]
     */
    getHints: function(value) {
      var dataToSet = undefined;

      if (value === undefined) {
        dataToSet = this.storyProcessor.getHints(
          $(this.$refs["input-tag"]).val()
        );
      } else {
        dataToSet = this.storyProcessor.getHints(value);
      }

      this.selectedHints.loaded = true;
      this.selectedHints.hintData = dataToSet;
      this.selectedHints.controlMode = this.controlModes.hints;
    },

    /**
     * Return synonyms, based pon passed value
     * @param {string} value Word to find synonyms for - for example: sighed
     */
    getSynonyms: function(value) {
      var dataToSet = undefined;

      if (value === undefined) {
        dataToSet = this.storyProcessor.getSynonyms(
          $(this.$refs["input-tag"]).val()
        );
      } else {
        dataToSet = this.storyProcessor.getSynonyms(value);
      }

      this.selectedHints.loaded = true;
      this.selectedHints.hintData = dataToSet;
      this.selectedHints.controlMode = this.controlModes.synonyms;
    },

    /**
     * Process hints loaded from CSV file
     * @param {event} e Jquery fileLoaded event, from HTML File element
     */
    onFileLoaded: function(e) {
      this.storyProcessor.loadHintDataFromCsv(e.target);

      $(this.$refs["input-import-file"]).val("");
    }
  },
  created: function() {
    if (this.storyProcessor === undefined) {
      this.storyProcessor = new StoryProcessor();
    }
  },
  mounted: function() {
    var that = this;

    that.state = new machina.Fsm({
      initialState: "Loading",

      states: {
        Loading: {
          _onEnter: function() {
            that.$refs["main-busy-indicator"].showSpinner();
          },

          _onExit: function() {}
        },

        Loaded: {
          _onEnter: function() {
            that.$refs["main-busy-indicator"].hideAll();

            that.$emit(events.loaded);
          },

          _onExit: function() {}
        },

        LoadError: {
          _onEnter: function() {
            debugger;
            that.$refs["main-busy-indicator"].showError();
          },

          _onExit: function() {}
        }
      }
    });

    //that.storyProcessor = new StoryProcessor();

    $.when(
      that.storyProcessor.loadHintData()
    )
      .done(function() {
        that.state.transition("Loaded");
      })
      .fail(function() {
        that.state.transition("LoadError");
      });
  }
};
</script>
<style>
.hintValueLi:hover {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/TagTip.vue